const Top = ({ image }) => {
  return (
    <div className="md:flex md:justify-end border-b-4 border-gray-700">
      <img
        src={image}
        alt="Andrew sitting on his private jet"
        className="w-full md:w-[50vw] md:h-[90vh] md:sticky md:top-24 border-b-4 md:border-b-0 md:border-r-4 border-gray-700"
      />
      <div className="md:flex justify-end">
        <div className="w-full flex flex-col items-center px-10 py-10">
          <div className="text-white font-bold text-3xl sm:text-5xl">
            HUSTLER'S UNIVERSITY 2.0
          </div>
          <div className="text-gray-300 text-xl sm:text-2xl lg:text-3xl pt-5 sm:pt-8">
            A community where me and dozens of War Room soldiers will teach YOU
            exactly how to make money. This is a community where you will have
            access to stock analysis, options plays, crypto analysis, DeFi,
            E-commerce, Copywriting, Freelancing, Flipping, Financial planning,
            Business management and more.
          </div>
          <div className="text-gray-300 text-xl sm:text-2xl lg:text-3xl pt-5 sm:pt-8">
            Every professor is verified by me personally. Each one of them is
            making anywhere from 10k to 500k a month in their select field. I
            chose fields that ANYONE ANYWHERE can do NOW to get rich. No
            bullshit, no fluff, just hard hitting lessons in making money. Full
            resources, full lesson plans, everything you need to get rich and it
            all starts with you making your first income TODAY.
          </div>
          <div className="text-gray-300 text-xl sm:text-2xl lg:text-3xl pt-5 sm:pt-8">
            You have no more excuses, I just took them all away. Buckle up. It's
            time to get rich. Welcome to Hustler's University 2.0
          </div>
          <div className="text-gray-300 font-bold text-xl sm:text-2xl lg:text-3xl pt-6 sm:pt-10 sm:pb-5 pb-8">
            And, it's $49 to enroll TODAY.
          </div>
          <a
            href="https://bit.ly/3PvH1Lj"
            className="px-20 py-3 text-xl border-2 border-rose-600 text-white hover:bg-zinc-800 active:bg-zinc-900 outline-none"
          >
            Enroll Now
          </a>
        </div>
      </div>
    </div>
  );
};

export default Top;
